import { Injectable } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { UserLoginService } from 'src/app/user-login/user-login.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogsearchvarService {

  constructor(
    private sharedService: SharedService,
  ) {
    this.sharedService.userLoggedoff_.subscribe(()=>{
      this.logSelectedIndex = 0;
    })
  }

  logSearchMeta=this.sharedService.metaData.logsearch;
  // searchStats = this.logSearchMeta.log_search_defaults.searchStats
  searchInstructions = this.logSearchMeta.log_search_defaults.searchInstructions
  threatHuntingTemplates = this.logSearchMeta.log_search_defaults.threatHuntingTemplates

  searchStats=[
    {
      "disp":"Average events/Day :",
      "stats":"",
      "value":"average_events"
    }, 
    {
      "disp":"Total events today :",
      "stats":"",
      "value":"total_events_today"
    },
    {
      "disp":"Events this week :",
      "stats":"",
      "value":"events_this_week"
    },
    {
      "disp":"Total events :",
      "stats":"",
      "value":"total_events"
    }
  ]

  // searchInstructions=[
  //   { "disp": "Set time range", "value": "Select the period you want to search." },
  //   { "disp": "Choose log source", "value": "Pick the relevant log type or index." },
  //   { "disp": "Enter search criteria", "value": "Add filters such as user, IP, or event type." },
  //   { "disp": "Run & review results", "value": "Execute the search and analyze the events." },
  //   { "disp": "Investigate or save", "value": "Pivot for details, then save, export, or alert." }
  // ]

  // threatHuntingTemplates=[
  //   {
  //     "name": "High Bandwidth Sessions",
  //     "description": "Detects sessions transferring unusually large volumes of data.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Traffic & Policy"
  //   },
  //   {
  //     "name": "Traffic by Service and Port",
  //     "description": "Summarizes traffic distribution by service name and destination port.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Traffic & Policy"
  //   },
  //   {
  //     "name": "Suspicious Outbound Traffic",
  //     "description": "Highlights unusual or high-risk outbound connections.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Threat & Security"
  //   },
  //   {
  //     "name": "Multiple Denied Connections from Single Source",
  //     "description": "Identifies sources repeatedly blocked by firewall rules.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Threat & Security"
  //   },
  //   {
  //     "name": "Port Scanning Attempts",
  //     "description": "Detects sources attempting connections across many destination ports.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Behavior & Anomaly"
  //   },
  //   {
  //     "name": "Repeated Policy Violations",
  //     "description": "Shows hosts repeatedly violating firewall policies.",
  //     "platform": "Firewall - FortiGate",
  //     "section": "Behavior & Anomaly"
  //   },
  
  //   {
  //     "name": "Top Denied Source IPs",
  //     "description": "Lists source IPs generating the highest number of denied connections.",
  //     "platform": "Firewall - Cisco ASA",
  //     "section": "Traffic & Access"
  //   },
  //   {
  //     "name": "VPN Connection Attempts",
  //     "description": "Tracks VPN login successes and failures.",
  //     "platform": "Firewall - Cisco ASA",
  //     "section": "Traffic & Access"
  //   },
  //   {
  //     "name": "Authentication Failures",
  //     "description": "Displays failed authentication attempts.",
  //     "platform": "Firewall - Cisco ASA",
  //     "section": "Security Events"
  //   },
  //   {
  //     "name": "Suspicious Inbound Connections",
  //     "description": "Highlights potentially malicious inbound traffic.",
  //     "platform": "Firewall - Cisco ASA",
  //     "section": "Security Events"
  //   },
  //   {
  //     "name": "Firewall Configuration Changes",
  //     "description": "Tracks changes made to firewall configuration.",
  //     "platform": "Firewall - Cisco ASA",
  //     "section": "Operational"
  //   },
  
  //   {
  //     "name": "Intrusion Events by Severity",
  //     "description": "Groups intrusion events by risk and severity level.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Threat Intelligence"
  //   },
  //   {
  //     "name": "Malware File Detections",
  //     "description": "Lists files identified as malicious by Firepower.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Threat Intelligence"
  //   },
  //   {
  //     "name": "Threat Intelligence Blocked Traffic",
  //     "description": "Shows traffic blocked using threat intelligence feeds.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Threat Intelligence"
  //   },
  //   {
  //     "name": "Command-and-Control Detections",
  //     "description": "Detects traffic communicating with known C2 servers.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Threat Intelligence"
  //   },
  //   {
  //     "name": "Top Applications by Traffic Volume",
  //     "description": "Identifies applications consuming the most bandwidth.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Traffic Analysis"
  //   },
  //   {
  //     "name": "High-Risk Applications in Use",
  //     "description": "Shows usage of applications classified as high risk.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Traffic Analysis"
  //   },
  //   {
  //     "name": "Blocked Applications Summary",
  //     "description": "Summarizes application-level blocks.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "Traffic Analysis"
  //   },
  //   {
  //     "name": "User-Based Access Violations",
  //     "description": "Detects policy violations associated with specific users.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "User & Host"
  //   },
  //   {
  //     "name": "Host with Multiple Threat Detections",
  //     "description": "Identifies hosts triggering multiple security alerts.",
  //     "platform": "Firewall - Cisco Firepower",
  //     "section": "User & Host"
  //   },
  
  //   {
  //     "name": "MAC Address Flapping Events",
  //     "description": "Detects MAC addresses rapidly moving between ports.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Network Activity"
  //   },
  //   {
  //     "name": "High Broadcast or Multicast Traffic",
  //     "description": "Identifies excessive broadcast or multicast activity.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Network Activity"
  //   },
  //   {
  //     "name": "Top Talkers by Interface",
  //     "description": "Shows interfaces generating the highest traffic volumes.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Network Activity"
  //   },
  //   {
  //     "name": "Port Security Violations",
  //     "description": "Detects unauthorized devices connecting to switch ports.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Security"
  //   },
  //   {
  //     "name": "Unauthorized Device Connections",
  //     "description": "Identifies devices violating network access policies.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Security"
  //   },
  //   {
  //     "name": "DHCP Snooping Violations",
  //     "description": "Flags suspicious DHCP server behavior.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Security"
  //   },
  //   {
  //     "name": "ARP Inspection Failures",
  //     "description": "Detects ARP spoofing or poisoning attempts.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Security"
  //   },
  //   {
  //     "name": "Interface Up / Down Events",
  //     "description": "Tracks switch interface status changes.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Operational"
  //   },
  //   {
  //     "name": "Spanning Tree Topology Changes",
  //     "description": "Identifies changes in STP topology.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Operational"
  //   },
  //   {
  //     "name": "Configuration Change Events",
  //     "description": "Tracks modifications to switch configuration.",
  //     "platform": "Network - Cisco Switch",
  //     "section": "Operational"
  //   },
  
  //   {
  //     "name": "Failed Login Attempts",
  //     "description": "Lists unsuccessful login attempts.",
  //     "platform": "Operating System - Windows",
  //     "section": "Authentication & Access"
  //   },
  //   {
  //     "name": "Successful Logins Outside Business Hours",
  //     "description": "Detects logins occurring outside defined working hours.",
  //     "platform": "Operating System - Windows",
  //     "section": "Authentication & Access"
  //   },
  //   {
  //     "name": "Multiple Failed Logins from Same Source",
  //     "description": "Identifies potential brute-force login attempts.",
  //     "platform": "Operating System - Windows",
  //     "section": "Authentication & Access"
  //   },
  //   {
  //     "name": "Privileged Account Logins",
  //     "description": "Tracks logins using administrative accounts.",
  //     "platform": "Operating System - Windows",
  //     "section": "Authentication & Access"
  //   },
  //   {
  //     "name": "Possible Brute Force Attacks",
  //     "description": "Detects repeated authentication failures in short time windows.",
  //     "platform": "Operating System - Windows",
  //     "section": "Threat & Suspicious Activity"
  //   },
  //   {
  //     "name": "New Service Installed",
  //     "description": "Identifies new Windows services added to systems.",
  //     "platform": "Operating System - Windows",
  //     "section": "Threat & Suspicious Activity"
  //   },
  //   {
  //     "name": "Suspicious Process Creation",
  //     "description": "Detects execution of uncommon or high-risk processes.",
  //     "platform": "Operating System - Windows",
  //     "section": "Threat & Suspicious Activity"
  //   },
  //   {
  //     "name": "PowerShell Execution Events",
  //     "description": "Tracks PowerShell usage for investigation.",
  //     "platform": "Operating System - Windows",
  //     "section": "Threat & Suspicious Activity"
  //   },
  
  //   {
  //     "name": "Top Sources Generating Denied Events",
  //     "description": "Identifies sources most frequently blocked across platforms.",
  //     "platform": "Cross-Platform - Vendor-Agnostic",
  //     "section": "Threat & Security"
  //   },
  //   {
  //     "name": "High Severity Security Events",
  //     "description": "Shows events marked with high or critical severity.",
  //     "platform": "Cross-Platform - Vendor-Agnostic",
  //     "section": "Threat & Security"
  //   },
  //   {
  //     "name": "Traffic Spikes by Time Window",
  //     "description": "Detects sudden increases in traffic volume.",
  //     "platform": "Cross-Platform - Vendor-Agnostic",
  //     "section": "Traffic & Behavior"
  //   },
  //   {
  //     "name": "Internal Hosts Communicating Externally",
  //     "description": "Lists internal systems initiating external connections.",
  //     "platform": "Cross-Platform - Vendor-Agnostic",
  //     "section": "Traffic & Behavior"
  //   }
  // ]

  saveSearchError={
    "saveResultNameAlreadyExists":"Result name already exists",
    "required":"*Result name cannot be empty",
    "invalidName":"Invalid result name"
  }
  saveSearchttlError={
    "required":"*TTL cannot be empty",
    "invalidInput":"TTL must be a number"
  }

  partitionLimit:number = 2

  apiCalled = false

  timeUnit=[
    {
        "disp": "Mins",
        "value": 60
    },
    {
        "disp": "Hours",
        "value": 3600
    },
    {
      "disp":"Days",
      "value":86400
    }
];

public _spinner = new BehaviorSubject({"index":0,"state":false});
public $spinner = this._spinner.asObservable();

setSpinner(index : number,state: boolean) {
  this._spinner.next({index:index,state:state});
}


  tabChanges = 1

  threatHuntNameErrMsg={
    "required":"*Threat hunt name is mandatory",
    "threatHuntNameAlreadyExists":"Threat hunt name already exists",
    "invalidName":"Invalid name"
  }

  threatHuntTableHeaders=["NAME","CREATED BY","SAVED TIME"]

  historyTableHeaders=["CREATED TIME",'SOURCES',"QUERY"]

  historyTitles={
    "delete":"Delete",
    "selected": "Selected",
    "remove_fav":"Remove from favourites",
    "remove_saved":"Remove from saved search",
    "no_result":"No result",
    "replace_popup":"Do you want to replace the existing query?",
    "no":"No",
    "yes":"Yes"
  }

  threatHuntingTabsLimit =5

  searchOverviewTitles={
    "stats":"Stats",
    "instructions":"Instructions",
    "templates":"Templates",
    "platform":"Platform :",
    "section":"Section :",
    "description":"Description :",
    "explore":"Explore",
    "explore_contents":"Explore Contents",
    "threat_hunting_templates":"Threat Hunting Templates"
  }

  notepadCellTitles={
    "filter_by":"Filter By:",
    "hashTag":"#",
    "rows":"rows,",
    "columns":"columns,",
    "result_in":"Result in",
    "save_search":"SAVE SEARCH",
    "name_label":"Name : ",
    "time_to_live":"TTL(Time To Live) : ",
    "save":"SAVE",
    "cancel":"CANCEL"
  }

  notepadTitles={
    "save_as":"Save as",
    "save":"Save",
    "save_as_header":"SAVE AS",
    "name":"Name:",
    "visibility":"Visibility:",
    "cancel":"Cancel"
  }

  logsearchTitles={
    "no_result":"No result Found"
  }

  titles={
    "historyTitles": {
      "delete": "Delete",
      "selected": "Selected",
      "remove_fav": "Remove from favourites",
      "remove_saved": "Remove from saved search",
      "no_result": "No result",
      "replace_popup": "Do you want to replace the existing query?",
      "no": "No",
      "yes": "Yes"
    },
    "searchOverviewTitles": {
      "stats": "Stats",
      "instructions": "Instructions",
      "templates": "Templates",
      "platform": "Platform :",
      "section": "Section :",
      "description": "Description :",
      "explore": "Explore",
      "explore_contents": "Explore Contents",
      "threat_hunting_templates": "Threat Hunting Templates"
    },
    "notepadCellTitles": {
      "filter_by": "Filter By:",
      "hashTag": "#",
      "rows": "rows,",
      "columns": "columns,",
      "result_in": "Result in",
      "save_search": "SAVE SEARCH",
      "name_label": "Name : ",
      "time_to_live": "TTL(Time To Live) : ",
      "save": "SAVE",
      "cancel": "CANCEL"
    },
    "notepadTitles": {
      "save_as": "Save as",
      "save": "Save",
      "save_as_header": "SAVE AS",
      "name": "Name:",
      "visibility": "Visibility:",
      "cancel": "Cancel"
    },
    "logsearchTitles": {
      "no_result": "No result Found"
    }
  }

  gotThreatHuntList$: Subject<boolean> = new Subject();

  addTab$: Subject<boolean> = new Subject();

  logSelectedIndex:number = 0;
  logSearchSelectedIndex=0;

  threatHuntUpdateMode:boolean =false

  addToSearch={
    "state":false,
    "query":"",
    "partitions":[],
    "id":0
  }
  public _addToSearch = new Subject<any | null>();
  public $addToSearch = this._addToSearch.asObservable();

  tabsList=[]
  visibilityOptions=[
    {
      "disp":"Private",
      "value":"private"
    },
    {
      "disp":"Public",
      "value":"public"
    }
  ]

  threatDetectionList = [
    {
      "name": "Threat 1",
      "savedTime": "2026-02-05 14:11:13",
      "notepadCollection": [
        {
          "id": 3,
          "text": "Item 4",
          "sqlquery": "action != \"value\" | calculate count() as \"count()\"| BY action | FETCH \"count()\" ",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "traffic"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 7 Days",
            "value": [
              "-",
              "day",
              6,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "firewall_fortigate",
            "time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 08:41:13"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 14:11:13",
            "hosts": [
              "traffic"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 08:41:13"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "Event",
                "tags": "Select all",
                "index": 0,
                "value": "event",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "Traffic",
                "tags": "Select all",
                "index": 1,
                "value": "traffic",
                "selected": false,
                "isSelected": true
              }
            ],
            "platform": "firewall_fortigate",
            "platformfields": [],
            "time_range_disp": "Last 7 Days",
            "uniqueHostsList": [
              "traffic"
            ],
            "selectedTimeStructure": {
              "disp": "Last 7 Days",
              "value": [
                "-",
                "day",
                6,
                0
              ]
            }
          }
        },
        {
          "id": 2,
          "text": "Item 3",
          "sqlquery": " (EventID = \"4104\" AND (Channel = \"Microsoft-Windows-PowerShell/Operational\" OR Channel = \"PowerShellCore/Operational\") AND \n  EventID CONTAINS (\"CL_Mutexverifiers.ps1,runAfterCancelProcess\"))  |fetch EventID,EventID,Channel",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "DESKTOP-3P7M7J2"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 1 Year",
            "value": [
              "-",
              "year",
              1,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "windows",
            "time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 08:59:15"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 14:29:15",
            "hosts": [
              "DESKTOP-3P7M7J2"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 08:59:15"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "DESKTOP-3P7M7J2",
                "tags": "Select all",
                "index": 0,
                "value": "DESKTOP-3P7M7J2",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "LAPTOP-BM1VM8JA",
                "tags": "Select all",
                "index": 1,
                "value": "LAPTOP-BM1VM8JA",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-UOBD4BO2",
                "tags": "Select all",
                "index": 2,
                "value": "LAPTOP-UOBD4BO2",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-X1500EA",
                "tags": "Select all",
                "index": 3,
                "value": "LAPTOP-X1500EA",
                "selected": false,
                "isSelected": false
              }
            ],
            "platform": "windows",
            "platformfields": [],
            "time_range_disp": "Last 2 Months",
            "uniqueHostsList": [
              "DESKTOP-3P7M7J2"
            ],
            "selectedTimeStructure": {
              "disp": "Last 2 Months",
              "value": [
                "-",
                "month",
                2,
                0
              ]
            }
          }
        }
      ]
    },
    {
      "name": "Threat 2",
      "savedTime": "2026-02-05 14:11:13",
      "notepadCollection": [
        {
          "id": 3,
          "text": "Item 4",
          "sqlquery": "action != \"value\" | calculate count() as \"count()\"| BY action | FETCH \"count()\" ",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "traffic"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 7 Days",
            "value": [
              "-",
              "day",
              6,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "firewall_fortigate",
            "time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 08:41:13"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 14:11:13",
            "hosts": [
              "traffic"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 08:41:13"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "Event",
                "tags": "Select all",
                "index": 0,
                "value": "event",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "Traffic",
                "tags": "Select all",
                "index": 1,
                "value": "traffic",
                "selected": false,
                "isSelected": true
              }
            ],
            "platform": "firewall_fortigate",
            "platformfields": [],
            "time_range_disp": "Last 7 Days",
            "uniqueHostsList": [
              "traffic"
            ],
            "selectedTimeStructure": {
              "disp": "Last 7 Days",
              "value": [
                "-",
                "day",
                6,
                0
              ]
            }
          }
        },
        {
          "id": 2,
          "text": "Item 3",
          "sqlquery": " (EventID = \"4104\" AND (Channel = \"Microsoft-Windows-PowerShell/Operational\" OR Channel = \"PowerShellCore/Operational\") AND \n  EventID CONTAINS (\"CL_Mutexverifiers.ps1,runAfterCancelProcess\"))  |fetch EventID,EventID,Channel",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "DESKTOP-3P7M7J2"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 1 Year",
            "value": [
              "-",
              "year",
              1,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "windows",
            "time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 08:59:15"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 14:29:15",
            "hosts": [
              "DESKTOP-3P7M7J2"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 08:59:15"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "DESKTOP-3P7M7J2",
                "tags": "Select all",
                "index": 0,
                "value": "DESKTOP-3P7M7J2",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "LAPTOP-BM1VM8JA",
                "tags": "Select all",
                "index": 1,
                "value": "LAPTOP-BM1VM8JA",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-UOBD4BO2",
                "tags": "Select all",
                "index": 2,
                "value": "LAPTOP-UOBD4BO2",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-X1500EA",
                "tags": "Select all",
                "index": 3,
                "value": "LAPTOP-X1500EA",
                "selected": false,
                "isSelected": false
              }
            ],
            "platform": "windows",
            "platformfields": [],
            "time_range_disp": "Last 2 Months",
            "uniqueHostsList": [
              "DESKTOP-3P7M7J2"
            ],
            "selectedTimeStructure": {
              "disp": "Last 2 Months",
              "value": [
                "-",
                "month",
                2,
                0
              ]
            }
          }
        }
      ]
    },
    {
      "name": "Threat 3",
      "savedTime": "2026-02-05 15:37:07",
      "notepadCollection": [
        {
          "id": 3,
          "text": "Item 4",
          "sqlquery": "dstip in ('142.54.161.133')  |  FETCH time,srcip",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "Built TCP state-bypass connection",
            "Drop Rate Exceeded",
            "Egress interface changed from inside to outside",
            "Egress interface changed from outside to inside",
            "firepower"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 7 Days",
            "value": [
              "-",
              "day",
              6,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "ftd_cisco",
            "time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 10:06:39"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 15:36:39",
            "hosts": [
              "Built TCP state-bypass connection",
              "Drop Rate Exceeded",
              "Egress interface changed from inside to outside",
              "Egress interface changed from outside to inside",
              "firepower"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-29 18:30:00",
              "2026-02-05 10:06:39"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "Built TCP state-bypass connection",
                "tags": "Select all",
                "index": 0,
                "value": "Built TCP state-bypass connection",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "Drop Rate Exceeded",
                "tags": "Select all",
                "index": 1,
                "value": "Drop Rate Exceeded",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "Egress interface changed from inside to outside",
                "tags": "Select all",
                "index": 2,
                "value": "Egress interface changed from inside to outside",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "Egress interface changed from outside to inside",
                "tags": "Select all",
                "index": 3,
                "value": "Egress interface changed from outside to inside",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "firepower",
                "tags": "Select all",
                "index": 4,
                "value": "firepower",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "Invalid transport field",
                "tags": "Select all",
                "index": 5,
                "value": "Invalid transport field",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "Teardown TCP state-bypass connection",
                "tags": "Select all",
                "index": 6,
                "value": "Teardown TCP state-bypass connection",
                "selected": false,
                "isSelected": false
              }
            ],
            "platform": "ftd_cisco",
            "platformfields": [],
            "time_range_disp": "Last 7 Days",
            "uniqueHostsList": [
              "Built TCP state-bypass connection",
              "Drop Rate Exceeded",
              "Egress interface changed from inside to outside",
              "Egress interface changed from outside to inside",
              "firepower"
            ],
            "selectedTimeStructure": {
              "disp": "Last 7 Days",
              "value": [
                "-",
                "day",
                6,
                0
              ]
            }
          }
        },
        {
          "id": 3,
          "text": "Item 4",
          "sqlquery": " NOT (srcip IN ($cust_publicip,$private_ip )) AND dstip IN ($cust_publicip,$private_ip ) \n | CALCULATE sum(sentbyte) | BY action,service | FETCH all ",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "event",
            "traffic"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 30 Days",
            "value": [
              "-",
              "day",
              29,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "firewall_fortigate",
            "time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 10:07:05"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 15:37:05",
            "hosts": [
              "event",
              "traffic"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 10:07:05"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "Event",
                "tags": "Select all",
                "index": 0,
                "value": "event",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "Traffic",
                "tags": "Select all",
                "index": 1,
                "value": "traffic",
                "selected": false,
                "isSelected": true
              }
            ],
            "platform": "firewall_fortigate",
            "platformfields": [],
            "time_range_disp": "Between 27 Dec 2025 00:00:00 and 27 Dec 2025 08:51:00",
            "uniqueHostsList": [
              "event",
              "traffic"
            ],
            "selectedTimeStructure": {
              "disp": "Between 27 Dec 2025 00:00:00 and 27 Dec 2025 08:51:00",
              "value": [
                "2025-12-27 00:00:00",
                "2025-12-27 08:51:00"
              ]
            }
          }
        },
        {
          "id": 2,
          "text": "Item 3",
          "sqlquery": " (EventID = \"4104\" AND (Channel = \"Microsoft-Windows-PowerShell/Operational\" OR Channel = \"PowerShellCore/Operational\") AND \n  EventID CONTAINS (\"CL_Mutexverifiers.ps1,runAfterCancelProcess\"))  |fetch EventID,EventID,Channel",
          "showResultSection": false,
          "platform": "",
          "selectedHosts": [
            "DESKTOP-3P7M7J2"
          ],
          "data": null,
          "filters": [],
          "timeRange": {
            "disp": "Last 1 Year",
            "value": [
              "-",
              "year",
              1,
              0
            ]
          },
          "limit": true,
          "searchRequest": {
            "platform": "windows",
            "time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 10:07:07"
            ],
            "user_name": "Super@centiyent.com",
            "time": "2026-02-05 15:37:07",
            "hosts": [
              "DESKTOP-3P7M7J2"
            ],
            "page_no": 1,
            "items_per_page": 25,
            "filter_by": [],
            "field_name": [],
            "total_no_events": 0,
            "selected_time_range": [
              "2026-01-19 00:00:00",
              "2026-02-05 10:07:07"
            ],
            "fetched_trail_details": {},
            "direction": 0
          },
          "resultReceivedState": false,
          "editor": {},
          "impactedHosts": {
            "value": [
              {
                "disp": "DESKTOP-3P7M7J2",
                "tags": "Select all",
                "index": 0,
                "value": "DESKTOP-3P7M7J2",
                "selected": false,
                "isSelected": true
              },
              {
                "disp": "LAPTOP-BM1VM8JA",
                "tags": "Select all",
                "index": 1,
                "value": "LAPTOP-BM1VM8JA",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-UOBD4BO2",
                "tags": "Select all",
                "index": 2,
                "value": "LAPTOP-UOBD4BO2",
                "selected": false,
                "isSelected": false
              },
              {
                "disp": "LAPTOP-X1500EA",
                "tags": "Select all",
                "index": 3,
                "value": "LAPTOP-X1500EA",
                "selected": false,
                "isSelected": false
              }
            ],
            "platform": "windows",
            "platformfields": [],
            "time_range_disp": "Last 2 Months",
            "uniqueHostsList": [
              "DESKTOP-3P7M7J2"
            ],
            "selectedTimeStructure": {
              "disp": "Last 2 Months",
              "value": [
                "-",
                "month",
                2,
                0
              ]
            }
          }
        }
      ]
    }
  ]

}

